<template>
    <v-card class="mb-2" :elevation="!fullCard ? 0 : undefined" variant="outlined">
        <v-list-item lines="three">
            <div class="d-flex flex-column flex-md-row">
                <div class="align-self-start" :class="{'pl-2': !fullCard}">
                    <v-list-item-title class="wrap-words">
                        <div
                            class="wrap-words d-flex align-center text-subtitle-1 font-weight-bold cursor-pointer mb-1"
                        >
                            <span>
                                {{ title }}
                            </span>
                            <ProductOfferTipsDialog v-if="offer.tipsAvailable" :offer-key="offer.offerKey" />
                        </div>
                        <div v-if="useDiscountDetails" class="d-flex flex-shrink-0 width-max-content">
                            <special-offer-label :details="useDiscountDetails" />
                        </div>
                        <div v-if="offer.available" class="d-flex align-center text-caption">
                            <v-icon :title="$t('available')" start size="small" class="text-success">
                                mdi-checkbox-marked-circle
                            </v-icon>
                            <span class="text-success" v-text="$t('available')" />
                        </div>
                        <div v-if="secondaryServiceName" class="d-flex align-center text-caption">
                            <v-icon size="small" start class="text-info">mdi-information-outline</v-icon>
                            <span class="text-caption">{{ secondaryServiceName }}</span>
                        </div>
                        <div v-else class="d-flex align-center text-caption">
                            <v-icon :title="$t('on_request')" start size="small" class="text-warning">
                                mdi-alert-circle
                            </v-icon>
                            <span class="text-warning" v-text="$t('on_request')" />
                        </div>
                        <div v-if="offerData" class="d-flex align-center text-caption">
                            <v-icon size="small" start>mdi-calendar</v-icon>
                            <span>
                                {{ `${$filters.dateFormat(offerData)}` }}
                            </span>
                        </div>
                        <template v-if="offer && offer.price && showPriceDuringSearch">
                            <discount-label :price="offer.price" class="d-inline-block" />
                            <span class="text-caption">
                                <conditions-label
                                    :offer-key="offer.offerKey"
                                    :price="offer.price"
                                    @conditions="showConditionsInfo"
                                />
                            </span>
                        </template>
                        <div v-if="offerTariff" class="d-flex align-center text-caption">
                            <v-icon start size="small" class="text-info">mdi-tag-text</v-icon>
                            <span>{{ offerTariff }}</span>
                        </div>
                    </v-list-item-title>
                </div>
                <v-spacer />
                <div
                    v-if="!hideBtn"
                    class="offer-price align-self-end align-self-md-center d-flex flex-column align-center"
                >
                    <slot name="price" :offer="offer">
                        <template v-if="!offer.soldOut">
                            <supplier-price v-if="!authStore.isAgency" :supplier-price="offer.supplierPrice" />
                            <v-btn
                                variant="flat"
                                :color="currentlySelected ? 'success' : 'primary'"
                                size="small"
                                no-prefetch
                                block
                                height="36px"
                                max-height="36px"
                                @click="action(clickPriceButton)"
                            >
                                {{ label($filters.price(offer.price)) }}
                                <v-icon v-if="currentlySelected" end>mdi-check</v-icon>
                            </v-btn>
                            <template v-if="showPriceDuringSearch">
                                <price-note :search-request="searchRequest" />
                                <commission-amount :commission="offer.price.commission" />
                            </template>
                        </template>
                        <sold-out-modal v-else small />
                    </slot>
                </div>
            </div>
        </v-list-item>
    </v-card>
</template>
<script setup lang="ts">
    import CommissionAmount from '@/components/snippets/CommissionAmount.vue'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import ConditionsLabel from '~src/components/snippets/conditionsLabel.src'
    import {EventBus, SHOW_ACTIVITY_CONDITIONS_INFO} from '@/utils/event-bus'
    import PriceNote from '@/components/snippets/PriceNote.vue'
    import SpecialOfferLabel from '~/components/hotels/search/offers/SpecialOfferLabel.vue'
    import SupplierPrice from '~src/components/snippets/supplierPrice.src'
    import ProductOfferTipsDialog from '~/components/modals/ProductOfferTipsDialog.vue'
    import SoldOutModal from '~src/components/snippets/SoldOutModal.vue'
    const {action, label, showPriceDuringSearch} = useBookingPriceButton()

    const props = defineProps<{
        offer: any
        title: string
        offerData?: any
        offerTariff?: any
        fullCard?: any
        searchRequest: any
        secondaryServiceName?: any
        offerInfo?: any
        selectedOffer?: any
        hideBtn?: boolean
    }>()

    const emit = defineEmits<{
        (e: 'select', value): void
    }>()

    const clickPriceButton = () => {
        emit('select', props.offer)
    }

    const useDiscountDetails = computed(() => {
        return props.offer?.price?.discountDetails
    })

    const currentlySelected = computed(() => {
        return props.offer.offerKey === props.selectedOffer?.offerKey
    })

    const showConditionsInfo = () => {
        EventBus.$emit(SHOW_ACTIVITY_CONDITIONS_INFO, props.offer)
    }
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';
    .offer-price {
        width: 20%;
    }
    @media #{map.get(settings.$display-breakpoints, 'xs')} {
        .offer-price {
            width: 25%;
        }
    }
    .wrap-words {
        white-space: normal;
    }
</style>
